export default {

    BomStatus: {
        NEW: 1,
        APPROVED: 2,
        READY_FOR_PICKUP: 3,
        DONE: 4,
        REJECTED: 99
    },

    SpbStatus: {
        NEW: 1,
        APPROVED: 2,
        RO_SUBMITTED: 3,
        READY_FOR_PICKUP: 4,
        DONE: 5,
        REJECTED: 99
    },

    SpkFlow: {
        REPAIR: 1,
        SCRAP: 2,
        QC: 20,
        DISMANTLE: 30,
        ASSEMBLY: 40
    },

    SpkFlowResult: {
        RTS: 5,
        JUNK: 7,
        CONTINUE_ASSY: 90
    },

    SpkWorkType: {
        REPAIR: 1,
        QC: 20,
        DISMANTLE: 30,
        ASSEMBLY: 40
    }

}
